import 'modern-normalize/modern-normalize.css';

import React from 'react';
import ReactDOM from 'react-dom';
import { App } from './app/app.component';

const rootElement = document.getElementById('root');
ReactDOM.render(<App />, rootElement);
